const tagsEnabled = document.querySelectorAll('[data-section-id]');
tagsEnabled.forEach((section) => {
  const tagButtons = section.querySelectorAll('.tag-button');
  tagButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      const selectedTag = this.getAttribute('data-tag');
      const sectionId = section.getAttribute('data-section-id');
      const articles = document.querySelectorAll(`[data-section-id='${sectionId}'] .grid-button`);
      articles.forEach((article) => {
        if (selectedTag === 'all' || article.classList.contains(selectedTag)) {
          article.style.display = 'block';
        } else {
          article.style.display = 'none';
        }
      });
      // Remove the "active" class from all buttons in this section
      tagButtons.forEach((btn) => {
        btn.classList.remove('active');
      });
      // Toggle the "active" class on the clicked button
      this.classList.toggle('active');
    });
  });
});
// const tagsEnabledCollection = document.querySelectorAll('[data-filter-id]');
// tagsEnabledCollection.forEach((section) => {
//   const tagButtons = section.querySelectorAll('.tag-button');
//   tagButtons.forEach((button) => {
//     button.addEventListener('click', function (event) {
//       event.preventDefault();
//       const selectedTag = this.getAttribute('data-tag');
//       const sectionId = section.getAttribute('data-filter-id');
//       const articles = document.querySelectorAll(`[data-filter-id='${sectionId}'] .grid-button`);
//       articles.forEach((article) => {
//         if (article.classList.contains(selectedTag) && article.classList.contains('all-collections')) {
//           article.style.display = 'block';
//         } else {
//           article.style.display = 'none';
//         }
//       });
//       // Remove the "active" class from all buttons in this section
//       tagButtons.forEach((btn) => {
//         btn.classList.remove('active');
//       });
//       // Toggle the "active" class on the clicked button
//       this.classList.toggle('active');
//     });
//   });
// });
const tagsEnabledCollection = document.querySelectorAll('[data-filter-id]');
tagsEnabledCollection.forEach((section) => {
  const tagButtons = section.querySelectorAll('.tag-button');
  const articles = section.querySelectorAll('.grid-button');

  // Hide all elements by default
  articles.forEach((article) => {
    article.style.display = 'none';
  });

  // Display elements with 'all-collections' class by default
  const allCollectionsElements = section.querySelectorAll('.grid-button.all-collections');
  allCollectionsElements.forEach((element) => {
    element.style.display = 'block';
  });

  tagButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      const selectedTag = this.getAttribute('data-tag');
      articles.forEach((article) => {
        // Check if the element has the clicked button's data-tag and 'all-collections' class
        if (article.classList.contains(selectedTag) && article.classList.contains('all-collections')) {
          article.style.display = 'block';
        } else {
          article.style.display = 'none';
        }
      });
      // Remove the "active" class from all buttons in this section
      tagButtons.forEach((btn) => {
        btn.classList.remove('active');
      });
      // Toggle the "active" class on the clicked button
      this.classList.toggle('active');
    });
  });
  // Call the sortList function for each section when the page loads
  sortList(section);
});

// Sorting the List Aplha
// function sortList(section) {
//   var list, i, switching, b, shouldSwitch;
//   list = section.querySelector("ul"); // Get the ul element within the current section
//   switching = true;
//   /* Make a loop that will continue until
//   no switching has been done: */
//   while (switching) {
//     // start by saying: no switching is done:
//     switching = false;
//     b = list.getElementsByTagName("LI");
//     // Loop through all list-items:
//     for (i = 0; i < (b.length - 1); i++) {
//       // start by saying there should be no switching:
//       shouldSwitch = false;
//       /* check if the next item should
//       switch place with the current item: */
//       if (b[i].innerHTML.toLowerCase() > b[i + 1].innerHTML.toLowerCase()) {
//         /* if the next item is alphabetically
//         lower than the current item, mark as a switch
//         and break the loop: */
//         shouldSwitch = true;
//         break;
//       }
//     }
//     if (shouldSwitch) {
//       /* If a switch has been marked, make the switch
//       and mark the switch as done: */
//       b[i].parentNode.insertBefore(b[i + 1], b[i]);
//       switching = true;
//     }
//   }
// }
function sortList(section) {
  var list, i, switching, b, shouldSwitch;
  list = section.querySelector("ul"); // Get the ul element within the current section
  switching = true;
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // start by saying: no switching is done:
    switching = false;
    b = list.getElementsByTagName("LI");
    var firstElement = Array.from(b).find((item) => containsText(item, "All Collections"));
    // Loop through all list-items:
    for (i = 0; i < (b.length - 1); i++) {
      // start by saying there should be no switching:
      shouldSwitch = false;
      /* check if the next item should
      switch place with the current item: */
      if (b[i] === firstElement) {
        // Move 'All Collections' element to the beginning
        var parentNode = b[i].parentNode;
        parentNode.insertBefore(b[i], b[0]);
      } else if (containsText(b[i], b[i + 1].textContent)) {
        /* if the next item is alphabetically
        lower than the current item, mark as a switch
        and break the loop: */
        shouldSwitch = true;
        break;
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark the switch as done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
    }
  }
}

function containsText(element, text) {
  return element.textContent.toLowerCase().indexOf(text.toLowerCase()) !== -1;
}